import { render } from "./Ou.vue?vue&type=template&id=ee4d6d6a"
import script from "./Ou.vue?vue&type=script&lang=js"
export * from "./Ou.vue?vue&type=script&lang=js"
script.render = render

export default script